import React, {FC, ReactNode, useState} from 'react';
import Tooltip from '@mui/material/Tooltip';
import LoadingSpinner from '../../loadingSpinner/loadingSpinner';
import EmptyBigCard from './emptyBigCard';
import InfoIcon from '../../../assets/icons/info-icon.svg';
import { t } from 'i18next';
import dayjs from "dayjs";
import {useDashboardFilterDateStore, useHistogramFilterDateStore} from "../../../store/dateRangeStore";

interface DashboardBigCardProps {
    title: string;
    isLoading?: boolean;
    isError?: boolean;
    children: ReactNode;
    info?: string;
    hasMoreThan12Months?: boolean;
    onYearClick?: (year: any) => void;
    headerRight?: React.ReactNode;
}

const DashboardBigCard: FC<DashboardBigCardProps> = (props) => {
    const currentYear = new Date().getFullYear();
    const lastYears = [currentYear - 2 ,currentYear - 1, currentYear];
    const { setHistogramFilterDateRange, setUserSelected } = useHistogramFilterDateStore();

    const handleYearClick = (year: number) => {
        const fromDate = dayjs(`${year}-01-01`).startOf('day');
        const toDate = dayjs(`${year}-12-31`).endOf('day');
        setHistogramFilterDateRange([fromDate, toDate]);
        setUserSelected(true);
    };

    return (
        <div className="text-cliprounded-[8px] flex h-full flex-col">
            <div className="mb-4 flex max-h-[47px] items-center text-primary justify-between gap-4 rounded-t-[8px] border-b px-5 py-2">
                <div className="flex items-center gap-4">
                    <h2 className="text-[18px] font-[500] text-primary">{props.title}</h2>
                    {props.info && (
                        <Tooltip title={props.info}>
                            <img src={InfoIcon} alt="" className="max-w-[20px]" />
                        </Tooltip>
                    )}
                </div>

                {props.hasMoreThan12Months && (
                    <div className="flex items-center gap-2">
                        {lastYears.map((year) => (
                            <span
                                key={year}
                                className="hover:cursor-pointer hover:underline"
                                onClick={() => {
                                    handleYearClick(year);
                                }}
                            >
                        {year}
                      </span>
                        ))}
                    </div>
                )}
                {props.headerRight && (
                    <div className="flex  gap-[68px]">
                        {props.headerRight}
                    </div>
                )}
            </div>

            <div className="flex flex-1 flex-col px-[20px]">
                {!props.isError && !props.children && (
                    <div className="flex h-full -translate-y-[40px] flex-col items-center justify-center gap-4 text-center">
                        {!props.isLoading ? (
                            <EmptyBigCard />
                        ) : (
                            <LoadingSpinner center color="primary" />
                        )}
                    </div>
                )}

                {!props.isError && !props.isLoading && props.children && props.children}

                {props.isError && <p>There was an error retrieving the data</p>}
            </div>
        </div>
    );
};

export default DashboardBigCard;
